import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import HtmlExportService from '../../services/HtmlExportService';

const HtmlExportButton = (props: { handleOnExport: (data: Blob) => void, loading: boolean }): React.ReactElement => {
  const { handleOnExport, loading } = props;

  return (
    <Button className="btn btn-outline-secondary" startIcon={<FontAwesomeIcon style={{ fontSize: '14px', fontWeight: '700' }} icon={faDownload} />} onClick={() => handleOnExport(HtmlExportService())}>
      {loading ? <CircularProgress sx={{ marginLeft: 1 }} color="inherit" size={15} /> : 'Export'}
    </Button>
  );
};

export default HtmlExportButton;
